import { SET_SECONDARY_STATE } from "../types/secondaryOrderTypes";

export const setSecondaryState = (initialState: any, payload: any) => {

  if (payload?.outletId !== initialState?.outletId) {
    payload = { ...payload, diffShippingAddress: false };
  } else {
    payload = { ...payload, diffShippingAddress: payload?.diffShippingAddress };
  }

  return {
    type: SET_SECONDARY_STATE,
    payload,
  };
};


export const resetSecondaryState = () => ({
  type: "RESET_SECONDARY_STATE",
  payload: {},
});

